module.exports = __webpack_public_path__ + "static/media/A_bubbly_ux.3c9f2eee.png";